<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    @hideModal="hideModal()"
    size="xl"
  >
    <template #header>
      {{$t('routes.EXSBOrderShow')}}
    </template>
    <template #body>
      <Show :id-order="idOrder"></Show>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Show from '../Show'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ShowModal',

  props: ['idOrder'],

  components: {
    BaseModal,
    Show
  },

  computed: {
    ...mapGetters({
      isVisible: 'exsborder/showModal/isVisible'
    })
  },

  watch: {
  },

  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsborder/showModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
